import { GameListener, GameLogic } from 'game-logic';
import { RoundResultSubmitter } from './round-result-submitter';

export class RemoteRoundResultSubmitter implements RoundResultSubmitter {
  private readonly gameListener: GameListener;

  constructor(gameListener: GameListener) {
    this.gameListener = gameListener;
  }

  public submitResult(game: GameLogic, isComplete: boolean): Promise<void> {
    const moves = game.serializeCommandList();

    this.gameListener.onGameComplete(moves, isComplete);

    return Promise.resolve();
  }
}
